import { Loading } from 'atom/loader'
import React, { useEffect } from 'react'
import { useHistory } from 'react-router'
import { log } from '../../logger'

export const CognitoLogoutPage: React.FC = () => {
  const history = useHistory()

  useEffect(() => {
    log('Cognito logout page - redirecting to home')
    // Small delay to show the logout message, then redirect
    const timer = setTimeout(() => {
      history.push('/')
    }, 1000)

    return () => clearTimeout(timer)
  }, [history])

  return <Loading size={'large'} />
}
